import { FC } from 'react'

import { propsWithClassNames } from '@trustycars/genie-ui/functions'

import useTOTPBlock from '$actions/useTOTPBlock'

import {
  description as descriptionStyle,
  header,
  title as titleStyle
} from '$blocks/common/auth.css'
import OTPInput from '$elements/OTPInput'

import { otp } from './styles.css'

export type TOTPBlockProps = ReturnType<typeof useTOTPBlock>

export const TOTPBlock: FC<TOTPBlockProps> = ({
  otpInput,
  title,
  description
}) => (
  <>
    <header className={header}>
      <h2 className={titleStyle}>{title}</h2>

      <p className={descriptionStyle}>{description}</p>
    </header>

    <main className={otp.main}>
      <OTPInput autoFocus {...propsWithClassNames(otpInput, otp.field)} />
    </main>
  </>
)

export default TOTPBlock
